import { createSlice } from '@reduxjs/toolkit';

// Stato iniziale dei filtri
const initialState = {
  // Filtri selezionati dall'utente ma non ancora applicati
  selectedFilters: {
    brands: [],
    lines: [],
    genders: [],
    modelTypes: [],
    age: []
  },
  // Filtri effettivamente applicati alla visualizzazione
  appliedFilters: {
    brands: [],
    lines: [],
    genders: [],
    modelTypes: [],
    age: []
  },
  // Termine di ricerca
  searchTerm: '',
  // Flag che indica se i filtri sono stati applicati
  isFiltersApplied: false
};

// Creazione della slice
const arsCatalogFiltersSlice = createSlice({
  name: 'arsCatalogFilters',
  initialState,
  reducers: {
    // Imposta i filtri selezionati
    setSelectedFilters: (state, action) => {
      state.selectedFilters = {
        ...state.selectedFilters,
        ...action.payload
      };
    },

    // Imposta un singolo tipo di filtro selezionato
    setSelectedFilterType: (state, action) => {
      const { filterType, values } = action.payload;
      state.selectedFilters[filterType] = values;
    },

    // Applica i filtri selezionati
    applyFilters: (state) => {
      state.appliedFilters = { ...state.selectedFilters };
      state.isFiltersApplied = true;
    },

    // Pulisce tutti i filtri
    clearFilters: (state) => {
      state.selectedFilters = {
        brands: [],
        lines: [],
        genders: [],
        modelTypes: [],
        age: []
      };
      state.appliedFilters = {
        brands: [],
        lines: [],
        genders: [],
        modelTypes: [],
        age: []
      };
      state.isFiltersApplied = false;
    },

    // Imposta il termine di ricerca
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    }
  }
});

// Esporta le azioni
export const {
  setSelectedFilters,
  setSelectedFilterType,
  applyFilters,
  clearFilters,
  setSearchTerm
} = arsCatalogFiltersSlice.actions;

// Esporta i selettori
export const selectSelectedFilters = (state) => state.arsCatalogFilters.selectedFilters;
export const selectAppliedFilters = (state) => state.arsCatalogFilters.appliedFilters;
export const selectSearchTerm = (state) => state.arsCatalogFilters.searchTerm;
export const selectIsFiltersApplied = (state) => state.arsCatalogFilters.isFiltersApplied;

// Esporta il reducer
export default arsCatalogFiltersSlice.reducer;
